import { useTranslation } from "react-i18next";

const languageOptions = [
  { code: "zh-TW", label: "繁中" },
  { code: "zh-CN", label: "简中" },
  { code: "en", label: "English" },
  { code: "ja", label: "日本語" },
] as const;

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const activeLanguage = languageOptions.some(
    (option) => option.code === i18n.resolvedLanguage,
  )
    ? i18n.resolvedLanguage
    : "zh-TW";

  return (
    <label className="inline-flex items-center gap-1.5 rounded-full border border-current/20 bg-white/85 px-2.5 py-1 text-xs font-medium text-foreground-800 shadow-sm backdrop-blur-sm">
      <span aria-hidden="true">文</span>
      <span className="sr-only">{t("lang.label", { defaultValue: "Language" })}</span>
      <select
        value={activeLanguage}
        onChange={(event) => void i18n.changeLanguage(event.target.value)}
        aria-label={t("lang.label", { defaultValue: "Language" })}
        className="cursor-pointer bg-transparent outline-none"
      >
        {languageOptions.map((option) => (
          <option key={option.code} value={option.code}>
            {t(`lang.${option.code}`, { defaultValue: option.label })}
          </option>
        ))}
      </select>
    </label>
  );
}

